import { useNavigate } from "react-router-dom";
import useStore from "../store/store";
import axios from "axios";

const useLogout = () => {
  const navigate = useNavigate();
  const clearUser = useStore((state) => state.clearUser);

  const handleLogout = () => {
    // Clear user data from Zustand store
    clearUser();

    // Remove Authorization header
    delete axios.defaults.headers.common["Authorization"];

    // Navigate to login page
    navigate("/signin");
  };

  return { handleLogout };
};

export default useLogout;
